import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ContractedEmployeeDto } from "../api-clients";
import { OdataBase } from "./base-odata.service";

@Injectable({ providedIn: "root" })
export class ContractedEmployeeOdata {
  private _entityName = "ContractedEmployee";

  public constructor(private odata: OdataBase<ContractedEmployeeDto>) {}

  public getAllContractedEmployees(): Observable<ContractedEmployeeDto[]> {
    return this.odata.GetAll(this._entityName);
  }
}
